/**
 * Test page para BioTemplatePremium — Internacional (USD + Stripe Subscription Checkout).
 * Acceso protegido: requiere ?key=delfuocampo-dev-2024
 */

import { BRAND_PERSON_NAME } from "@/lib/brandConfig";
import BioTemplatePremium from "@/components/templates/BioTemplatePremium";
import {
  getPlansForCurrency,
} from "@/config/bioTemplatePremiumPlans";
import {
  getPremiumInvitePaths,
  PREMIUM_INVITE_FLOW_NAME,
} from "@/config/bioTemplatePremiumFlow";
import { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

const DEV_KEY = "delfuocampo-dev-2024";

export default function TestPremiumInternacional() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [authorized, setAuthorized] = useState(false);

  useEffect(() => {
    const key = searchParams.get("key");
    if (key === DEV_KEY) {
      setAuthorized(true);
    } else {
      navigate("/", { replace: true });
    }
  }, [searchParams, navigate]);

  if (!authorized) {
    return null;
  }

  const { standardPlan, vipPlan } = getPlansForCurrency("USD", "en-US");
  const { successPath, cancelPath } = getPremiumInvitePaths("USD");
  
  // Detectar si hay promoción especial activa
  const specialOfferEnv = (import.meta.env.VITE_PREMIUM_SPECIAL_OFFER as string)?.toLowerCase().trim();
  const isSpecialOfferActive = specialOfferEnv === "true" || specialOfferEnv === "1" || specialOfferEnv === "active";
  const activeDiscountMode = isSpecialOfferActive ? "immediate" : "recovery_modal";

  return (
    <>
      {/* Badge de modo - z-10 para no tapar modales */}
      <div className="fixed top-4 left-4 z-10 px-3 py-2 bg-purple-500/20 backdrop-blur-sm border border-purple-500/40 rounded-lg text-white text-xs font-bold pointer-events-none">
        🌎 Test: Internacional (USD)
      </div>

      {/* Info de variables - z-10 para no tapar modales */}
      <div className="fixed top-4 right-4 z-10 px-3 py-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg text-white text-xs space-y-1 max-w-[200px] pointer-events-none">
        <div className="font-bold mb-1">Active variables:</div>
        <div className="text-[10px] text-gray-300 space-y-0.5">
          <div>Standard: ${standardPlan.price} USD</div>
          <div>VIP: ${vipPlan.price} USD</div>
          <div className="text-purple-300 mt-1">Gateway: Stripe</div>
          <div className="text-purple-300">Mode: Subscription</div>
          {vipPlan.playbackId && <div className="text-green-300">VIP Video: ✓</div>}
          <div className={`mt-1 font-bold ${activeDiscountMode === "immediate" ? "text-yellow-300" : "text-purple-300"}`}>
            Discount: {activeDiscountMode === "immediate" ? "🔥 IMMEDIATE" : "💜 RECOVERY"}
          </div>
        </div>
      </div>

      <BioTemplatePremium
        currency="USD"
        country="US"
        language="en-US"
        standardPlan={standardPlan}
        vipPlan={vipPlan}
        successPath={successPath}
        cancelPath={cancelPath}
        profileName={BRAND_PERSON_NAME}
        flowName={PREMIUM_INVITE_FLOW_NAME}
      />
    </>
  );
}
